import Image from "next/image";
import React from "react";
import { MdLocationPin, MdNotListedLocation } from "react-icons/md";
import { Marker } from "react-map-gl/mapbox";

import styles from "./MapMarker.module.scss";

const MapMarker = ({
  latitude,
  longitude,
  anchor = "bottom",
  active = false,
  offset = [0, 0],
  onClick,
  iconName,
  iconColor = "var(--dark-background)",
  visible = true,
}) => {
  const markerProps = {
    color: active ? "var(--accent-1)" : iconColor,
    size: active ? 50 : 40,
    className: styles.marker,
  };

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      anchor={anchor}
      onClick={onClick}
      offset={offset}
      style={{ display: visible ? "block" : "none" }}
    >
      {iconName === "WhereNextLogo" && (
        <Image
          src="/assets/img/icons/wherenext-logo-outline.svg"
          alt="Where Next Logo map pin"
          width={active ? 50 : 40}
          height={active ? 50 : 40}
          className={`${styles.marker}`}
        />
      )}
      {iconName === "GoogleMapsMarker" && (
        <Image
          src="/assets/img/icons/google-md-map-marker-red.svg"
          alt="Where Next Logo map pin"
          width={active ? 50 : 40}
          height={active ? 50 : 40}
          className={`${styles.marker}`}
        />
      )}
      {iconName === "MdLocationPin" && <MdLocationPin {...markerProps} />}
      {(!iconName || iconName === "MdNotListedLocation") && (
        <MdNotListedLocation {...markerProps} />
      )}
    </Marker>
  );
};

export default React.memo(MapMarker);
